import { IEntityUpdate } from '@/interfaces'
import { Constants } from './constants'
import { AttaHttpClientFactory } from './http/AttaHttpClientFactory'

const http = AttaHttpClientFactory.create(Constants.API.AttaServices.host)

export class Update {
	/**
	 * Faz alterações na proposta
	 * @param propostaCancelamentoRequest
	 * @returns
	 */
	static async updateEntity(entity: IEntityUpdate) {
		const response = await http.post('/update', entity)
		return response
	}
}
